import React, { useState, useEffect } from "react";
import axios from "../../axios";
import { get, pad } from "lodash";
import { useNavigate, useLocation } from "react-router-dom";
import { connect } from "react-redux";
import * as actionTypes from "../../store/actions";
import moment from "moment";
import { Field, Form, Formik } from "formik";
import Select from "react-select";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import "react-datepicker/dist/react-datepicker.css";
import "./payment.css";
import Input from "../../components/Input";
import Overlay from "../../components/Overlay";
import { Modal } from "../../components/Modal";
import { bottom } from "@popperjs/core";
import BlockToggle from "../../components/Toglebutton/Togle";
import {
    extractDate,
    extractOnlyDate,
    maskToken,
    uploadImage,
    subadminAccessChange,
} from "../../utils/functions";
import { MdOutlineFileDownload } from "react-icons/md";

// Mui & material UI
import Stack from "@mui/material/Stack";
import Switch from "@mui/material/Switch";
import Tooltip from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";
import SearchBar from "material-ui-search-bar";
import FormGroup from "@mui/material/FormGroup";
import Typography from "@mui/material/Typography";
import Pagination from "@mui/material/Pagination";
import { makeStyles } from "@material-ui/core/styles";
import { TextField, Popover, Box } from "@mui/material";
import PaginationItem from "@mui/material/PaginationItem";
import FormControlLabel from "@mui/material/FormControlLabel";
import {
    Paper,
    Checkbox,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TablePagination,
    capitalize,
} from "@material-ui/core";

// icons
import { HiOutlineBars3BottomLeft } from "react-icons/hi2";
import { IoDocumentTextOutline } from "react-icons/io5";
import { GoDownload } from "react-icons/go";
import { AiOutlineDownload } from "react-icons/ai";
import { SlClose } from "react-icons/sl";
import { GrApple } from "react-icons/gr";
import { TbEyeShare } from "react-icons/tb";
import { IoIosLogOut } from "react-icons/io";
import { FaEyeSlash } from "react-icons/fa6";
import { RiDeleteBin6Line } from "react-icons/ri";
import { PiAndroidLogoFill } from "react-icons/pi";
import { TiInfoOutline, TiTick } from "react-icons/ti";
import { RxCross2, RxCrossCircled } from "react-icons/rx";
import { HiMiniArrowLeft, HiMiniArrowRight } from "react-icons/hi2";
import { BsDot, BsEyeFill, BsPlus, BsThreeDotsVertical } from "react-icons/bs";
import { MdBlock, MdClose, MdOutlineStarPurple500 } from "react-icons/md";
import { IoArchive, IoArrowBackCircleOutline, IoArrowForwardCircleOutline } from "react-icons/io5";
import {
    FaUser,
    
} from "react-icons/fa";
import * as XLSX from 'sheetjs-style';
import { saveAs } from "file-saver";

import { IoEyeOutline } from "react-icons/io5";
import { TiInfoLarge } from "react-icons/ti";

// import ReactReadMoreReadLess from "react-read-more-read-less";

import EyeIcon from "../../assets/images/eye.png";
import UserIcon from "../../assets/images/human.png";
import Card from "../../assets/images/cardData.png";
import vector from "../../assets/images/Vector.png";

import {
    DashboardContainer,
    DashboardWrapper,
    DashboardHeading,
    SearchFilterContainer,
    DashHeading,
    Button,
    ProfileDetailForm,
    
} from "./PaymentElement";
import YearInput from "../../components/YearInput";
import NoResults from "../../components/NoResult";
import Loading from "../../components/Loading";
import { PiExportBold } from "react-icons/pi";

const useStyles = makeStyles((theme) => ({
    table: {
        borderCollapse: 'separate',
        borderSpacing: '0 6px', // adds vertical spacing between rows
    },
    tableMainContainer: {
        maxHeight: "65vh",
        overflowX: "auto",
        overflowY: "auto",
        borderTopLeftRadius: "4px",
        borderTopRightRadius: "4px",

        // border: "1px solid rgba(17, 153, 38, 0.20)",

        // Optional scrollbar customization
        '&::-webkit-scrollbar': {
            height: '6px',
        },
        '&::-webkit-scrollbar-thumb': {
            backgroundColor: '#5088FB',     // Scrollbar color
            borderRadius: '4px',
        },
        '&::-webkit-scrollbar-track': {
            backgroundColor: '#f1f1f1',
        },
    },
    tableHeadingRow: {
        position: "sticky", // Make header sticky
        top: 0, // Stick to the top
        zIndex: 1, // Ensure it appears above other rows
        background: "#FFFFFF", // Header background color
        // border: "1px solid rgba(17, 153, 38, 0.20)",

    },
    tableBodyRow: {
        background: "#FFFFFF",
        border: "1px solid rgba(17, 153, 38, 0.20)",

        "&:hover": {
            backgroundColor: "#f5f5f5",
        },
    },
    tableHeadingCell: {
        // padding: "0.5rem 1rem !important",
        textAlign: "center",
        fontSize: "14px",
        color: "#1C2D28",
        fontWeight: "500",
        // border: "1px solid #D9E3D9",
        whiteSpace: "nowrap",
        background: "#FFFFFF",
        border: "none",

    },
    textMiddle: {
        padding: "0.3rem 1rem !important",
        verticalAlign: "middle !important",
        textAlign: "center",
        fontSize: "14px",
        color: "#484848",
        fontFamily: "Roboto",
        fontWeight: "400",
        background: "#FFFFFF",
        border: "none",


    },
    tablePaginationStyle: {
        borderTop: "1px solid #0000001a",
        borderRadius: "0rem 0rem 0.4rem 0.4rem",
        overflowY: "hidden",
    },
    paginationContainer: {
        marginTop: "2rem",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    }
}));

const PaymentManagement = ({ setUsers, userData, user }) => {
    const adminData = JSON.parse(localStorage.getItem("userData") || userData || sessionStorage.getItem("userData"));

    const paymentManagementPermissions = adminData?.adminpermissions?.modules?.find(
        (module) => module.moduleName === "Payment Management"
    )?.permissions || {};


    const canView = !!paymentManagementPermissions.view;
    const canAdd = !!paymentManagementPermissions.add;
    const canEdit = !!paymentManagementPermissions.edit;
    const canDelete = !!paymentManagementPermissions.delete;
    const canBlockUnblock = !!paymentManagementPermissions.blockUnblock;
    const canDownload = !!paymentManagementPermissions.download;

    const gigManagementPermissions = adminData?.adminpermissions?.modules?.find(
        (module) => module.moduleName === "Gigs Management"
    )?.permissions || {};

    const isSubAdminData = adminData?.userType === "subAdmin";

    // Check if view permissions in User Management are false
    const hasNoGigManagementPermissions = gigManagementPermissions &&
        !gigManagementPermissions.view


    const location = useLocation();
    const classes = useStyles();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [tableData, setTableData] = useState([]);
    const [cardData, setCardData] = useState([]);
    const [isVisible, setIsVisible] = useState(true); // Initial state
    const [excelData, setExcelData] = useState([]);

    const [userDetails, setUserDetails] = useState()
    const [statusPaymentData, setStatusPaymentData] = useState([])

    const [userInfo, setUserInfo] = useState([])
    const [anchorElData, setAnchorElData] = useState(null);





    const [tabSwitch, setTabSwitch] = useState(
        localStorage.getItem("filterTypeBookingData") || "1"

    ); // Default to ongoing

    const handleServiceTypeChangeData = (type) => {
        setTabSwitch(type);
        setIsLoading(true);
        localStorage.setItem("filterTypeBookingData", type); // Save the active tab to localStorage
    };




    // For Pagination
    const [page, setPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [totalDocs, setTotalDocs] = useState(0);

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(1); // Reset to the first page when rows per page change
    };

    const handleChangePage = (event, newPage) => {
        // handleCancel(); // your custom logic
        setPage(newPage); // this will trigger useEffect
    };

    // Filter Start
    const [startDate, setStartDate] = useState(null);
    const [filterDates, setFilterDates] = useState({
        startDate: "",
    });

    const [selectedTypeOption, setSelectedTypeOption] = useState(null); // For service type filtering
    const [selectedZipOption, setSelectedZipOption] = useState(null);
    const [allCategoryData, setAllCategoryData] = useState(); // For store all category
    const [selectedCategoryOption, setSelectedCategoryOption] = useState(null); // For category filtering
    const [selectedGigStatusOption, setSelectedGigStatusOption] = useState(null); // For Booking status filtering
    const [selectedBookingCancelled, setSelectedBookingCancelled] = useState(null); // For Booking Cancelled filtering
    const [selectedBookingRatings, setSelectedBookingRatings] = useState(null); // For Booking Ratings filtering
    const [selectedProviderRatings, setSelectedProviderRatings] = useState(null); // For provider Ratings filtering
    const [anchorEl, setAnchorEl] = useState(null);
    const [anchorElFilter, setAnchorElFilter] = useState(null);
    const [deleteModal, setDeleteModal] = useState(false);

    const [sorting, setSorting] = useState({
        sortBy: null,
        orderBy: null,
    });
    const [rotations, setRotations] = useState({
        sortBy: 0,
        orderBy: 0,
    });


    const [completeBookingData, setCompleteBookingData] = useState()

    // For Select checkbox
    const [selectedRows, setSelectedRows] = useState([]);

    useEffect(() => {
        if (tableData.length === 0) {
            setSelectedRows([]);
        }
    }, [tableData]);

    const handleSelectAll = (event) => {
        if (event.target.checked) {
            setSelectedRows(tableData.map((item) => item._id));
        } else {
            setSelectedRows([]);
        }
    };

    const handleSelectRow = (id) => {
        const newSelectedRows = selectedRows.includes(id)
            ? selectedRows.filter((rowId) => rowId !== id)
            : [...selectedRows, id];
        setSelectedRows(newSelectedRows);
    };

    const handleClearSelection = () => {
        setSelectedRows([]);
    };



    // This is for particular tab switch come from dashboard
    useEffect(() => {
        if (location?.state?.dashboardTab === "1" || location?.state?.dashboardTab === "2") {
            setTabSwitch(location.state.dashboardTab);
        }
    }, [location?.state?.dashboardTab]);


    const GigStatusOptions = [

        { value: 'processed', label: 'Failed' },
        { value: 'completed', label: 'Success' },
    ]

    const userTypeOptions = [
        { value: "0", label: "Failed" },
        { value: "1", label: "Success" },
    ];




    // default -> 0, bookingAccept -> 1, tripStarted -> 2, locksmithReached -> 3, serviceStarted -> 4


    const handleFilterClick = (event) => {
        setAnchorEl(event.currentTarget); // Open the filter popover
    };

    const handleApply = () => {
        if (!startDate && !selectedTypeOption && !selectedGigStatusOption) {
            toast.warning("Please select at least one field.", {
                position: "top-right",
            });
            return;
        }
        const adjustDateTime = (date, isEndOfDay = false) => {
            if (!date) return "";

            const adjustedDate = new Date(date);

            if (isEndOfDay) {
                adjustedDate.setHours(23, 59, 59, 999); // End of the day
            } else {
                adjustedDate.setHours(0, 0, 0, 0); // Start of the day
            }

            // Manually format to avoid time zone issues
            return `${adjustedDate.getFullYear()}-${String(adjustedDate.getMonth() + 1).padStart(2, "0")}-${String(adjustedDate.getDate()).padStart(2, "0")}T${String(adjustedDate.getHours()).padStart(2, "0")}:${String(adjustedDate.getMinutes()).padStart(2, "0")}:${String(adjustedDate.getSeconds()).padStart(2, "0")}.000Z`;
        };

        const normalizedStartDate = adjustDateTime(startDate, false); // Start of the day

        setFilterDates({
            startDate: normalizedStartDate,
        });

        setAnchorEl(null);
        setPage(1); // Reset to the first page
    };

    const handleCancel = () => {
        setStartDate(null);
        setFilterDates({ startDate: "" });

        setSelectedTypeOption(null); // Reset selected service type
        setSelectedCategoryOption(null); // Reset selected category
        setSelectedGigStatusOption(null); // Reset booking status
        setSelectedBookingCancelled(null); // Reset booking cancelled
        setSelectedBookingRatings(null); // Reset booking cancelled
        setSelectedProviderRatings(null); // Reset booking cancelled

        setPage(1);
    };

    const handleClose = () => {
        setAnchorEl(null); // Only close the popover without resetting
    };

    const handleStartDateChange = (date) => {
        setStartDate(date || null); // Update the start date if valid
    };

    const open = Boolean(anchorEl);
    const id = open ? "filter-popover" : undefined;


    const FilterClick = (event) => {
        setAnchorElFilter(event.currentTarget); // Open the filter popover
    };

    const handleCloseFilter = () => {
        setAnchorElFilter(null); // Only close the popover without resetting
    };

    const openFilter = Boolean(anchorElFilter);
    const ids = openFilter ? "filter-popover" : undefined;


    const handleClick = (event) => {
        setAnchorElData(event.currentTarget); // Open the filter popover
    };

    const openData = Boolean(anchorElData);
    const idData = openData ? "filter-popover" : undefined;

    const handleCloseData = () => {
        setAnchorElData(null); // Only close the popover without resetting
    };



    // For Search functionality
    const [searchTerm, setSearchTerm] = useState("");

    function myDeb(call, d = 1000) {
        let timer;
        return function (...args) {
            clearTimeout(timer);
            timer = setTimeout(() => {
                call(...args);
            }, d);
        };
    }

    const SearchAccountManagement = myDeb((search) => {
        setSearchTerm(search);
        setPage(1); // Reset to the first page on search
    });

    const cancelSearch = () => {
        setSearchTerm("");
        setPage(1); // Reset to the first page when search is canceled
    };



    // Get Booking Management Data
    useEffect(() => {
        getAllGigs(page);
        getTransactionExcelData()
            .then((res) => res.json())
            .then((data) => setExcelData(data))
            .catch((error) => console.error("Error fetching data:", error));

    }, [page, rowsPerPage, searchTerm, tabSwitch, filterDates]);


    const toggleSort = (field) => {
        setSorting((prev) => {
            let newSorting = {
                orderBy: null,
            };

            let newValue = prev[field] === 1 ? -1 : 1;
            newSorting[field] = newValue;

            // Agar orderBy 1 ya -1 ho, tabhi sortBy bhejna hai
            if (newValue === 1 || newValue === -1) {
                newSorting.sortBy = "hostUserName";
                newSorting.orderBy = newValue;
            }

            //Rotate image toggle
            setRotations((prev) => ({
                ...prev,
                [field]: prev[field] === 0 ? 180 : 0, // toggle between 0 and 180
            }));

            // API call
            getAllGigs(1, newSorting);

            return newSorting;
        });
    };

    const getAllGigs = async (currentPage, sortingParam = sorting) => {
        setIsLoading(true);
        setTotalDocs(0);

        try {
            const { data } = await axios.post(`/private/getTransactionData?page=${currentPage}&limit=${rowsPerPage}&search=${searchTerm}`,
                {
                    startDate: filterDates.startDate || undefined,
                    status: tabSwitch == "1"
                        ? (selectedTypeOption?.length ? selectedTypeOption.map((opt) => opt.value) : [])
                        : (selectedGigStatusOption?.length ? selectedGigStatusOption.map((opt) => opt.value) : []),
                    pageType: String(tabSwitch), // "1" for Inflow "2" for outflow
                    ...sortingParam,
                }
            );
            console.log("dgvdvgaajdata", data)

            setAllCategoryData(data);
            setTotalDocs(data?.data?.totalDocs);
            setTableData(data?.data?.docs)
        } catch (error) {
            if (error?.response?.status === 419) {
                localStorage.clear();
                Cookies.remove("showProfileSidebar");
                setUsers("");

                toast.error(`${error.response.data?.message}`, {
                    position: "top-right",
                });

                navigate("/");
            } else if (error?.response?.status === 901) {
                subadminAccessChange(navigate);
                toast.error(`${error.response.data?.message}`, {
                    position: "top-right",
                });
            } else {
                console.log("error", error?.response);
            }
        } finally {
            setIsLoading(false);
        }
    };




    const handleDownload = () => {
        // Format keys: convert camelCase to space-separated & capitalize, handle _id
        const formatKey = (key) => {
            if (key === '_id') return 'User Id';
            return key
                .replace(/([a-z])([A-Z])/g, '$1 $2')  // Add space before capital letters
                .replace(/^./, str => str.toUpperCase()); // Capitalize first letter
        };


        const formatValue = (key, value) => {
            if ((key === "createdAt") && value) {
                return new Date(value).toLocaleString("en-US", {
                    month: "2-digit",
                    day: "2-digit",
                    year: "numeric",
                });
            }
            return value;
        };


        // Format data with formatted headers
        const formattedData = excelData.map(item => {
            const newItem = {};
            Object.entries(item).forEach(([key, value]) => {
                newItem[formatKey(key)] = formatValue(key, value);
            });
            return newItem;
        });

        // Create worksheet from formatted data
        const worksheet = XLSX.utils.json_to_sheet(formattedData);

        // Auto-calculate column widths
        const keys = Object.keys(formattedData[0] || {});
        const colWidths = keys.map(key => {
            const maxLength = Math.max(
                key.length,
                ...formattedData.map(row => (row[key] ? row[key].toString().length : 0))
            );
            return { wch: maxLength + 2 };
        });
        worksheet["!cols"] = colWidths;

        // Bold header row (row 0)
        keys.forEach((key, index) => {
            const cellAddress = XLSX.utils.encode_cell({ c: index, r: 0 });
            if (worksheet[cellAddress]) {
                worksheet[cellAddress].s = {
                    font: { bold: true }
                };
            }
        });

        // Create workbook and append sheet
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

        // Write and download
        const excelBuffer = XLSX.write(workbook, {
            bookType: "xlsx",
            type: "array"
        });

        const data = new Blob([excelBuffer], { type: "application/octet-stream" });
        saveAs(data, "table_data.xlsx");
    };

    const getTransactionExcelData = async () => {

        try {
            const { data } = await axios.post(`/private/getTransactionExcelData`,
                {
                    pageType: String(tabSwitch)
                });
            setExcelData(data?.data);


        } catch (error) {
            if (error?.response?.status === 419) {
                localStorage.clear();
                Cookies.remove("showProfileSidebar");
                setUsers("");

                toast.error(`${error.response.data?.message}`, {
                    position: "top-right",
                });

                navigate("/");
            } else {
                console.log("error", error?.response)
            }
        } finally {
            setIsLoading(false);
        }
    };


    // Download invoice
    const invoiceDownload = async (_id) => {
        // setIsLoading(true); // Set loading before try block
        try {
            const response = await axios.get(`/invoicePaymentDownloadHtml/${_id}`, {
                responseType: "blob",  // Important to treat data as Blob
            });

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `jobDash_testing.pdf`);
            document.body.appendChild(link);
            link.click();
            link.remove();

            toast.success("Download successful!");
        } catch (error) {
            console.error("Download error:", error);
            toast.error("Something went wrong!");
        } finally {
            setIsLoading(false);
        }
    };




    return (
        <>
            <DashboardContainer>
                <DashboardWrapper >
                    <ProfileDetailForm>
                        <DashboardHeading style={{ marginBottom: "0.7rem" }}>
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                <div style={{ display: "flex", alignItems: "center", gap: "0.8rem", }}>
                                    <div className="common-heading">Payment Management</div>
                                    {isVisible ? (
                                        <BsEyeFill
                                            style={{
                                                fontSize: "1.2rem",
                                                color: "rgba(38, 52, 78, 1)",
                                                cursor: "pointer",
                                            }}
                                            onClick={() => setIsVisible(false)}
                                        />
                                    ) : (
                                        <FaEyeSlash
                                            style={{
                                                fontSize: "1.2rem",
                                                color: "rgba(38, 52, 78, 1)",
                                                cursor: "pointer",
                                            }}
                                            onClick={() => setIsVisible(true)}
                                        />
                                    )}
                                </div>


                                <div>
                                    {!(!canDownload && adminData?.userType === "subAdmin") && (
                                        <Button
                                            type="button"
                                            style={{ backgroundColor: "#5088FB", color: "#FFFFFF", border: "1px solid #5088FB", fontFamily: "Inter", fontSize: "14px", fontWeight: "400" }}
                                            onClick={handleDownload}
                                        >
                                            Export as xlsx <AiOutlineDownload style={{ fontSize: "1.2rem" }} />
                                        </Button>
                                    )}
                                </div>
                            </div>

                            {isVisible && (
                                <div className="user-card-container">
                                    <div className="cards">
                                        <div className="card-content">
                                            <div className="card-words">
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        gap: "0.3rem",
                                                    }}
                                                >
                                                    <span className="card-heading">Payment Inflow</span>
                                                    {/* <span className="card-title">&nbsp;</span> */}
                                                </div>
                                                <span className="card-price">
                                                    {/* {cardData?.totalBookings ? cardData?.totalBookings : 0} */}
                                                    $ {allCategoryData?.inflowAmount}
                                                </span>
                                            </div>
                                            <div className="card-icon" style={{ background: "#F3F7FF" }}>
                                                <FaUser
                                                    style={{ color: " #5080FB", fontSize: "1.3rem" }}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="cards">
                                        <div className="card-content">
                                            <div className="card-words">
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        gap: "0.3rem",
                                                    }}
                                                >
                                                    <span className="card-heading">Payment Outflow</span>
                                                    {/* <span className="card-title">&nbsp;</span> */}
                                                </div>
                                                <span className="card-price">
                                                    {/* {cardData?.ongoingBookings
                                                        ? cardData?.ongoingBookings
                                                        : 0} */}
                                                    $ {allCategoryData?.outflowAmount}
                                                </span>
                                            </div>
                                            <div className="card-icon" style={{ background: "#FFF3E3" }}>
                                                <img
                                                    src={UserIcon}
                                                    style={{ color: " #FDA517", fontSize: "1.3rem" }}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="cards">
                                        <div className="card-content">
                                            <div className="card-words">
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        gap: "0.3rem",
                                                    }}
                                                >
                                                    <span className="card-heading">Admin Earnings</span>
                                                    {/* <span className="card-title">(In a week)</span> */}
                                                </div>
                                                <span className="card-price">
                                                    {/* {cardData?.totalBookingsInWeeks
                                                        ? cardData?.totalBookingsInWeeks
                                                        : 0} */}
                                                    $ {allCategoryData?.totalCommissionFee}
                                                </span>
                                            </div>
                                            <div className="card-icon" style={{ background: "#EAFFED" }}>
                                                <img
                                                    src={EyeIcon}
                                                    style={{ color: " #2CA63F", fontSize: "1.3rem" }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </DashboardHeading>

                        <SearchFilterContainer>
                            <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }} >
                                <Button
                                    type="button"
                                    style={{
                                        backgroundColor:
                                            tabSwitch == "1" ? "#5088FB" : "",
                                        color: tabSwitch == "1" ? "#ffffff" : "#201D23",
                                        fontSize: "14px",
                                        fontFamily: "Inter",
                                        fontWeight: tabSwitch == "1" ? "700" : "400"
                                    }}
                                    onClick={() => {
                                        handleCancel();
                                        handleServiceTypeChangeData("1");
                                        setPage(1);
                                    }}
                                    disabled={tabSwitch == "1"}
                                >
                                    Payment Inflow{" "}
                                    {tabSwitch == "1"
                                        ? `(${isLoading ? "" : totalDocs})`
                                        : ""}
                                </Button>

                                <Button
                                    type="button"
                                    style={{
                                        backgroundColor:
                                            tabSwitch == "2" ? "#5088FB" : "",
                                        color: tabSwitch == "2" ? "#ffffff" : "#000000",
                                        fontSize: "14px",
                                        fontFamily: "Inter",
                                        fontWeight: tabSwitch == "2" ? "700" : "400"
                                    }}
                                    onClick={() => {
                                        handleCancel();
                                        handleServiceTypeChangeData("2");
                                        setPage(1);
                                    }}
                                    disabled={tabSwitch == "2"}
                                >
                                    Payment Outflow{" "}
                                    {tabSwitch == "2"
                                        ? `(${isLoading ? "" : totalDocs})`
                                        : ""}
                                </Button>

                            </div>
                            <div
                                style={{ display: "flex", alignItems: "center", gap: "0.8rem" }}
                            >
                                <SearchBar
                                    style={{
                                        minWidth: "23rem",
                                        height: "38px",
                                        borderRadius: "20px",
                                        backgroundColor: "#F8F9FB",
                                        color: "#212121",
                                        fontStyle: "Italic",
                                        fontWeight: 300,
                                        fontSize: "15px",
                                        fontFamily: "Roboto",
                                    }}
                                    className={"heightfix"}
                                    onChange={(e) => {
                                        SearchAccountManagement(e);
                                    }}
                                    onCancelSearch={cancelSearch}
                                    placeholder="Search Gig Id, Host Name Paid To...."
                                    inputProps={{ maxLength: 30 }}
                                />

                                <div>
                                    <Button
                                        type="button"
                                        style={{ backgroundColor: "#FFFFFF", color: "#667085", border: "1px solid #E0E2E7", fontFamily: "Inter", fontWeight: "500", borderRadius: "8px" }}
                                        onClick={handleFilterClick}
                                    >
                                        <div >Apply Filter <HiOutlineBars3BottomLeft style={{ fontSize: "1.5rem", color: "#000000" }} /></div>
                                    </Button>
                                </div>
                            </div>

                        </SearchFilterContainer>

                        {/* Filter Popover */}
                        <Popover
                            id={id}
                            open={open}
                            anchorEl={anchorEl}
                            onClose={handleClose}
                            anchorOrigin={{
                                vertical: "bottom",
                                horizontal: "left",
                            }}
                            transformOrigin={{
                                vertical: "top",
                                horizontal: "left",
                            }}
                        >
                            <Box sx={{ p: 2, width: "300px" }}>
                                <div
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                        marginBottom: "0.8rem",
                                    }}
                                >
                                    <div className="text-filter">Advance Filter</div>
                                    <div className="clear-filter" onClick={handleCancel}>
                                        Reset All
                                    </div>
                                </div>



                                <div className="mb-3">
                                    <label className="lable_name_data_text">Date</label>
                                    <YearInput
                                        selected={startDate}
                                        onChange={handleStartDateChange}
                                        placeholderText="Select Date"
                                        maxDate={new Date()}
                                        className="selectInput"
                                    // popperClassName="small-datepicker"
                                    />
                                </div>

                                {tabSwitch == "2" && (

                                    <div className="mb-3">
                                        <label className="lable_name_data_text">Gig Status</label>
                                        <Select
                                            isMulti
                                            value={selectedGigStatusOption}
                                            onChange={setSelectedGigStatusOption}
                                            options={GigStatusOptions}
                                            placeholder="Select Status"
                                            className="selectInput"

                                        />
                                    </div>
                                )}



                                {tabSwitch == "1" && (
                                    <div className="mb-3">
                                        <label className="lable_name_data_text">Gig Status</label>
                                        <Select
                                            isMulti
                                            value={selectedTypeOption}
                                            onChange={setSelectedTypeOption}
                                            options={userTypeOptions}
                                            placeholder="Select Status"
                                            className="selectInput"

                                        />
                                    </div>
                                )}

                                <Box
                                    sx={{ display: "flex", justifyContent: "center", mt: 3, gap: 2 }}
                                >
                                    <Button onClick={handleClose} color="secondary">
                                        Cancel
                                    </Button>
                                    <Button
                                        onClick={handleApply}
                                        style={{
                                            background: "#5088FB",
                                            color: "#ffffff",
                                            padding: "0px 15px"
                                        }}
                                    >
                                        Apply
                                    </Button>
                                </Box>
                            </Box>
                        </Popover>





                        <TableContainer className={classes.tableMainContainer}>
                            <Table className={classes.table}>
                                <TableHead>
                                    <TableRow className={classes.tableHeadingRow}>

                                        <TableCell className={classes.tableHeadingCell}>
                                            S.No
                                        </TableCell>
                                        {tabSwitch === "1" && (
                                            <>
                                              {!(!canDownload && adminData?.userType === "subAdmin") && (
                                                <TableCell className={classes.tableHeadingCell}>
                                                    Action
                                                </TableCell>
                                              )}
                                                <TableCell className={classes.tableHeadingCell}>
                                                    Payment Status
                                                </TableCell>
                                            </>
                                        )}
                                        {tabSwitch === "2" && (
                                            <TableCell className={classes.tableHeadingCell}>
                                                <div style={{ textAlign: "left", marginLeft: "4rem" }}>
                                                    Payment Status
                                                </div>
                                            </TableCell>
                                        )}

                                        <TableCell className={classes.tableHeadingCell}>
                                            Transaction ID
                                        </TableCell>
                                        <TableCell className={classes.tableHeadingCell}>
                                            Gig ID
                                        </TableCell>
                                        <TableCell className={classes.tableHeadingCell} >
                                            <div style={{ textAlign: "left", marginLeft: "2rem" }}>
                                                Host Name{" "}
                                                <img
                                                    src={vector}
                                                    style={{
                                                        cursor: "pointer",
                                                        transition: "transform 0.3s ease",
                                                        transform: `rotate(${rotations.orderBy}deg)`,
                                                    }}
                                                    onClick={() => toggleSort("orderBy")}
                                                />
                                            </div>
                                        </TableCell>
                                        <TableCell className={classes.tableHeadingCell}>
                                            <div style={{ textAlign: "left", marginLeft: "2rem" }}>
                                                Paid To
                                            </div>
                                        </TableCell>
                                        {tabSwitch === "1" && (
                                            <>
                                                <TableCell className={classes.tableHeadingCell} >
                                                    Paid on
                                                </TableCell>
                                                <TableCell className={classes.tableHeadingCell}>
                                                    Earnings ($)
                                                </TableCell>
                                                <TableCell className={classes.tableHeadingCell}>
                                                    Received On
                                                </TableCell>
                                            </>
                                        )}
                                    </TableRow>
                                </TableHead>
                                {isLoading && tableData && tableData.length > 0 ? (
                                    <TableBody>
                                        <TableRow>
                                            <TableCell colSpan={13} align="center" style={{ border: "none" }}>
                                                <Loading />
                                            </TableCell>
                                        </TableRow>
                                    </TableBody>
                                ) : tableData && tableData.length > 0 ? (
                                    <>
                                        <TableBody>
                                            {tableData.map((user, index) => (
                                                <TableRow className={classes.tableBodyRow} key={user._id}>
                                                    <TableCell className={classes.textMiddle}>
                                                        <div>{index + 1 + rowsPerPage * (page - 1)}</div>
                                                    </TableCell>
                                                    {tabSwitch === "1" && (
                                                        <>
                                                          {!(!canDownload && adminData?.userType === "subAdmin") && (
                                                            <TableCell className={classes.textMiddle}>
                                                                <div style={{
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    justifyContent: "center",
                                                                    gap: "5px",
                                                                    border: "1px solid #C3D3E2",
                                                                    borderRadius: "2px",
                                                                    height: "2rem",
                                                                    fontSize: "14px",
                                                                    fontFamily: "Roboto",
                                                                    fontWeight: "500",
                                                                    color: "#212121",
                                                                    cursor: "pointer",
                                                                    padding: "0px 10px"
                                                                }}
                                                                    onClick={() => invoiceDownload(user?._id)}
                                                                >
                                                                    <PiExportBold style={{ fontSize: "14px" }} /> Download
                                                                </div>
                                                            </TableCell>
                                                          )}

                                                            <TableCell className={classes.textMiddle}>



                                                                {(() => {
                                                                    let statusText = "N/A";

                                                                    // Determine statusText based on user?.availableBalanceStatus
                                                                    if (user?.availableBalanceStatus === "available") {
                                                                        statusText = "Success";
                                                                    } else if (user?.availableBalanceStatus === "pending") {
                                                                        statusText = "In Processing";
                                                                    } else if (user?.availableBalanceStatus === "failed") {
                                                                        statusText = "Failed";
                                                                    }

                                                                    // Styling map based on statusText
                                                                    const styleMap = {
                                                                        "Success": { color: "#44B155", background: "#EAFFED" },
                                                                        "Failed": { color: "#FF4141", background: "#FFF0F0" },
                                                                        "In Processing": { color: "#FDA517", background: "#FFF3E3" },
                                                                        "N/A": { color: "#999999", background: "#F2F2F2" }
                                                                    };

                                                                    const style = styleMap[statusText];

                                                                    return (
                                                                        <div
                                                                            style={{
                                                                                // padding: "3px 18px",
                                                                                width: "8rem",
                                                                                height: "1.5rem",
                                                                                // display: "flex",
                                                                                // alignItems: "center",
                                                                                // justifyContent: "center",
                                                                                alignContent: "center",
                                                                                borderRadius: "31px",
                                                                                whiteSpace: "nowrap",
                                                                                display: "inline-block",
                                                                                fontSize: "13px",
                                                                                ...styleMap[statusText]
                                                                            }}
                                                                        >
                                                                            <span style={{ display: "flex", gap: "1rem", alignItems: "center", justifyContent: "center" }}>
                                                                                {statusText}
                                                                                {(statusText === "Success" || statusText === "In Processing" || statusText === "Failed") && (
                                                                                    <TiInfoLarge
                                                                                        style={{
                                                                                            backgroundColor: statusText === "Success" ? "#44B155" : "#FDA517",
                                                                                            color: "#FFFFFF",
                                                                                            fontSize: "0.8rem",
                                                                                            cursor: "pointer",
                                                                                            borderRadius: "1rem",
                                                                                        }}
                                                                                        onClick={(e) => {
                                                                                            setStatusPaymentData(user || []);
                                                                                            setUserInfo(user);
                                                                                            handleClick(e)
                                                                                        }}
                                                                                    />
                                                                                )}
                                                                            </span>
                                                                        </div>

                                                                    );
                                                                })()}
                                                            </TableCell>
                                                        </>
                                                    )}
                                                    {tabSwitch === "2" && (
                                                        <TableCell className={classes.textMiddle}>
                                                            <div style={{

                                                                height: "1.5rem",
                                                                width: "8rem",
                                                                alignContent: "center",
                                                                marginLeft: "3rem",
                                                                borderRadius: "31px",
                                                                // color: get(user, "status", "---") === "completed" ? "#44B155" : "#FF4141",
                                                                background: get(user, "status", "---") === "completed" ? "#EAFFED" : "#FFF0F0"
                                                            }}>

                                                                {/* {get(user, "status", "---") === "completed" ? (
                                                                    <>
                                                                        Completed <IoEyeOutline style={{ fontSize: "1.2rem", cursor: "pointer", marginLeft: "0.6rem" }}
                                                                            onClick={(e) => {
                                                                                setUserDetails(user);
                                                                                FilterClick(e)
                                                                            }} />
                                                                    </>
                                                                ) : (
                                                                    "Fail"
                                                                )} */}
                                                                <>
                                                                    {(() => {
                                                                        const status = get(user, "status", "---");

                                                                        let label = "---";
                                                                        let color = "#999999"; // default grey

                                                                        switch (status) {
                                                                            case "completed":
                                                                                label = "Completed";
                                                                                color = "#44B155"; // green
                                                                                break;
                                                                            case "processed":
                                                                                label = "Processed";
                                                                                color = "#FDA517"; // orange
                                                                                break;
                                                                            case "failed":
                                                                                label = "Failed";
                                                                                color = "#FF4141"; // red
                                                                                break;
                                                                        }

                                                                        return (
                                                                            <span style={{ color, display: "inline-flex", alignItems: "center" }}>
                                                                                {label}
                                                                                <IoEyeOutline
                                                                                    style={{
                                                                                        fontSize: "1.2rem",
                                                                                        cursor: "pointer",
                                                                                        marginLeft: "0.6rem",
                                                                                        color,
                                                                                    }}
                                                                                    onClick={(e) => {
                                                                                        setUserDetails(user);
                                                                                        FilterClick(e);
                                                                                    }}
                                                                                />
                                                                            </span>
                                                                        );
                                                                    })()}
                                                                </>
                                                            </div>
                                                        </TableCell>
                                                    )}
                                                    <TableCell className={classes.textMiddle}>
                                                        <div>
                                                            {get(user, "transactionId", "---")}
                                                        </div>
                                                    </TableCell>
                                                    <TableCell className={classes.textMiddle}>
                                                        <div
                                                            style={{
                                                                color: "#29A4C0",
                                                                textDecoration: "underline",
                                                                cursor: "pointer",
                                                            }}
                                                            onClick={
                                                                !(isSubAdminData && hasNoGigManagementPermissions)
                                                                    ? () => navigate(`/gigOverview/${user.gigDetails._id}`, {
                                                                        state: { from: "paymentManagement" },
                                                                    })
                                                                    : undefined
                                                            }

                                                        // onClick={() => navigate(`/gigOverview/${user.gigDetails._id}`,
                                                        //     { state: { from: "paymentManagement" } })}
                                                        >
                                                            {get(user, "gigDetails.gigDetailId", "---")}
                                                        </div>
                                                    </TableCell>
                                                    <TableCell className={classes.textMiddle}>
                                                        <div
                                                            style={{
                                                                color: "#4D59FF",
                                                                textDecoration: "underline",
                                                                cursor: "pointer",
                                                                textAlign: "left",
                                                                marginLeft: "2rem"
                                                                // width: "6rem",
                                                            }}
                                                        // onClick={() => navigate(`/gigOverview/${user._id}`,
                                                        //     { state: { from: "gigsManagement" } })}
                                                        >
                                                            {get(user, "hostDetails.fullName", "---")}
                                                        </div>
                                                    </TableCell>
                                                    <TableCell className={classes.textMiddle}>
                                                        <div
                                                            style={{ color: "#FDA517", textDecoration: "underline", cursor: "pointer", textAlign: "left", marginLeft: "2rem" }}
                                                        // onClick={() => navigate(`/userDetails/${user.userId}`,
                                                        //     { state: { from: "gigsManagement" } })}
                                                        >
                                                            {get(user, "workerDetails.fullName", "---")}
                                                        </div>
                                                    </TableCell>

                                                    {tabSwitch === "1" && (
                                                        <>
                                                            <TableCell className={classes.textMiddle}>
                                                                <div>
                                                                    {extractOnlyDate(get(user, "createdAt", "---"))}
                                                                </div>
                                                            </TableCell>
                                                            <TableCell className={classes.textMiddle}>
                                                                <div >
                                                                    $ {Number(get(user, "amount", "0")).toFixed(2)}
                                                                </div>
                                                            </TableCell>
                                                            <TableCell className={classes.textMiddle}>
                                                                <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "0.5rem" }}>
                                                                    <div>
                                                                        <div>
                                                                            <img src={Card} style={{ height: "1.2rem" }} />
                                                                        </div>
                                                                        <div style={{ color: "#000000", fontSize: "11px" }}>{get(user, "cardDetails.brand", "N/A")}</div>
                                                                    </div>
                                                                    <div style={{
                                                                        fontfamily: "Roboto",
                                                                        fontweight: "400",
                                                                        fontsize: "13px",
                                                                        lineheight: "100%",
                                                                        letterspacing: "1%",
                                                                        textalign: "right",
                                                                        color: "#484848",
                                                                    }}>
                                                                        XXXX-XXXX-XXXX-{get(user, "cardDetails.last4", "N/A")}
                                                                    </div>
                                                                </div>
                                                            </TableCell>
                                                        </>
                                                    )}

                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </>
                                ) : (
                                    <>
                                        <TableBody>
                                            <TableRow>
                                                <TableCell
                                                    colSpan={13}
                                                    align="center"
                                                    style={{
                                                        padding: "2rem", border: "none",
                                                    }}
                                                >
                                                    <DashHeading
                                                        style={{ textAlign: "center", padding: "2rem" }}
                                                    >
                                                        <NoResults />
                                                    </DashHeading>
                                                </TableCell>
                                            </TableRow>
                                        </TableBody>
                                    </>
                                )}
                            </Table>
                        </TableContainer>
                        {(!isLoading && tableData && tableData.length > 0) && (
                            <>
                                <Stack spacing={2} className={classes.paginationContainer}>
                                    <Pagination
                                        count={Math.ceil(totalDocs / rowsPerPage)} // Total number of pages based on the count and rowsPerPage
                                        page={page}
                                        onChange={(event, value) => handleChangePage(event, value)} // Update page
                                        renderItem={(item) => (
                                            <PaginationItem
                                                slots={{
                                                    previous: HiMiniArrowLeft,
                                                    next: HiMiniArrowRight,
                                                }}
                                                {...item}
                                            />
                                        )}
                                    />
                                </Stack>
                            </>
                        )}
                    </ProfileDetailForm>
                </DashboardWrapper>
            </DashboardContainer >


            {/* Popover for user info */}
            <Popover
                id={ids}
                open={openFilter}
                anchorEl={anchorElFilter}
                onClose={handleCloseFilter}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "left",
                }}
            >
                <Box sx={{ p: 1.5, width: "320px" }}>
                    <div>
                        <div className="user_info">Bank Detail</div>

                        <div style={{ display: "flex", gap: "1rem", fontSize: "13px", marginTop: "10px" }}>
                            <div>
                                <div>Paid To</div>
                                <div>Paid On</div>
                                <div>Amount ($)</div>
                                <div>Admin Commission </div>
                                <div>Paid Through </div>
                            </div>
                            <div>
                                <div>:</div>
                                <div>:</div>
                                <div>:</div>
                                <div>:</div>
                                <div>:</div>
                            </div>
                            <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end" }}>
                                <div>{userDetails?.workerDetails?.firstName || "N/A"} {userDetails?.workerDetails?.lastName}</div>
                                <div>{extractOnlyDate(userDetails?.createdAt) || "N/A"}</div>
                                <div>$ {userDetails?.amount || "N/A"}</div>
                                <div>$ {userDetails?.totalPlatformCommissionFee || "N/A"}</div>
                                <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "0.5rem" }}>

                                    <div
                                        style={{
                                            fontFamily: "Roboto",
                                            fontWeight: "400",
                                            fontSize: "13px",
                                            lineHeight: "100%",
                                            letterSpacing: "1%",
                                            textAlign: "right",
                                            color: "#484848",
                                        }}
                                    >
                                        XXXX-XXXX-XXXX-
                                        {userDetails?.bankDetails?.accountNo
                                            ? userDetails.bankDetails.accountNo.slice(-4)
                                            : "N/A"}
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </Box>
            </Popover>


            {/* Filter Popover */}
            <Popover
                id={idData}
                open={openData}
                anchorEl={anchorElData}
                onClose={handleCloseData}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "left",
                }}
            >
                <Box sx={{ p: 2.3, width: "300px" }}>
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            marginBottom: "0.8rem",
                        }}
                    >
                        <div className="text-filter-cross">
                            <span>
                                {statusPaymentData?.availableBalanceStatus === "available"
                                    ? "Payment Success Detail"
                                    : statusPaymentData?.availableBalanceStatus === "pending"
                                        ? "Payment In Process Detail"
                                        : statusPaymentData?.availableBalanceStatus === "fail"
                                            ? "Payment Fail Reason"
                                            : null}
                            </span>
                        </div>
                        <div className="clear-filter-Cross" onClick={handleCloseData}>
                            <RxCross2 />
                        </div>


                    </div>

                    <div style={{ marginTop: "0.8rem" }}>

                        <div className="stepper-container">
                            {statusPaymentData?.availableBalanceStatus === "available" && (
                                <React.Fragment>
                                    <div className="stepper-item">
                                        <div className="stepper-line" />
                                        <div className="stepper-dot" />
                                        <div className="stepper-content">
                                            <div className="stepper-status">
                                                Payment transferred by {statusPaymentData?.hostDetails?.fullName}
                                            </div>
                                            <div className="stepper-date">
                                                {/* {statusPaymentData?.createdAt
                                                // ? extractDate(new Date(statusPaymentData.availableOn * 1000).toISOString())
                                                ? {extractOnlyDate(statusPaymentData?.createdAt)}
                                                : "N/A"} */}
                                                {statusPaymentData?.availableOn
                                                    ? extractDate(new Date(statusPaymentData.availableOn * 1000).toISOString())
                                                    : "N/A"}

                                            </div>
                                        </div>
                                    </div>
                                    <div className="stepper-item">
                                        <div className="stepper-line" />
                                        <div className="stepper-dot" />
                                        <div className="stepper-content">
                                            <div className="stepper-status">Added to Stripe Wallet On</div>
                                            <div className="stepper-date">
                                                {/* {statusPaymentData?.availableOn
                                                    ? extractDate(new Date(statusPaymentData.availableOn * 1000).toISOString())
                                                    : "N/A"} */}
                                                {statusPaymentData?.createdAt
                                                    ? extractDate(statusPaymentData.createdAt)
                                                    : "N/A"}
                                            </div>
                                        </div>
                                    </div>
                                </React.Fragment>
                            )}
                            {statusPaymentData?.availableBalanceStatus === "pending" && (
                                <React.Fragment>
                                    <div className="stepper-item">
                                        <div className="stepper-line" />
                                        <div className="stepper-dot" />
                                        <div className="stepper-content">
                                            <div className="stepper-status">
                                                Payment transferred by {statusPaymentData?.hostDetails?.fullName}
                                            </div>
                                            <div className="stepper-date">
                                                {/* {statusPaymentData?.availableOn
                                                    ? extractDate(new Date(statusPaymentData.availableOn * 1000).toISOString())
                                                    : "N/A"} */}
                                                {statusPaymentData?.createdAt
                                                    ? extractDate(statusPaymentData.createdAt)
                                                    : "N/A"}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="stepper-item">
                                        <div className="stepper-line" />
                                        <div className="stepper-dot" />
                                        <div className="stepper-content">
                                            <div className="stepper-status">Expected to add on Stripe Wallet on</div>
                                            <div className="stepper-date">
                                                {statusPaymentData?.availableOn
                                                    ? extractDate(new Date(statusPaymentData.availableOn * 1000).toISOString())
                                                    : "N/A"}
                                                {/* {statusPaymentData?.createdAt
                                                    ? extractDate(statusPaymentData.createdAt)
                                                    : "N/A"} */}
                                            </div>
                                        </div>
                                    </div>
                                </React.Fragment>
                            )}

                            {statusPaymentData?.availableBalanceStatus === "fail" && (
                                <div>

                                </div>
                            )}
                        </div>
                    </div>

                </Box>
            </Popover>

            {isLoading && <Overlay />
            }
        </>
    );
};

const mapStateToProps = (state) => {
    return {
        userData: state.userData,
        locationData: state.locations,
        defaultState: state.defaultState,
        sidebar: state.sidebar,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setUsers: (updatedValue) => {
            dispatch({
                type: actionTypes.UPDATE_USER,
                updatedUser: updatedValue,
            });
        },
        setDefaultState: (updatedValue) => {
            dispatch({
                type: actionTypes.UPDATE_DEFAULT,
                updateDefault: updatedValue,
            });
        },
        setSidebar: (updatedValue) => {
            dispatch({
                type: actionTypes.UPDATE_SIDEBAR,
                updateSidebar: updatedValue,
            });
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(PaymentManagement);


